import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { Checkbox } from '@morningtrain/react-fields'
import { isObservableArray } from 'mobx'

export default function RoleSelectorForPermission ({ selectedRoles = [], onChange }) {
  const name = useValue('name')

  const isSelected = (Array.isArray(selectedRoles) || isObservableArray(selectedRoles)) && selectedRoles.includes(name)

  return (
    <div>
      <Checkbox onChange={(status) => onChange(name, status)} defaultValue={isSelected} />
    </div>
  )
}
